import { Icon } from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch } from '@/Application/Hooks/Redux';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks/use-gtm-billing';
import { ClubType } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import { setIsRemoveClubParisModalOpen } from '@/modules/perseo-billing/store/slices/billing';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

import { ModalRemoveClubParis } from './modal-remove-club-paris.component';

const CLUB_TYPE_DETAILS: Record<ClubType, ClubDetails> = {
  [ClubType.HOME]: {
    icon: 'il-paris-home',
    name: 'Código Casa Paris:',
    title: 'Titular:'
  },
  [ClubType.WEDDING]: {
    icon: 'il-paris-rings',
    name: 'Código Novios Paris:',
    title: 'Pareja:'
  },
  [ClubType.BABY]: {
    icon: 'il-paris-baby',
    name: 'Código Bebé Paris:',
    title: 'Titular:',
    subtitle: 'Bebé:'
  }
};

interface ClubDetails {
  icon: 'il-paris-home' | 'il-paris-rings' | 'il-paris-baby';
  name: string;
  title: string;
  subtitle?: string;
}

interface IClubParisProps {
  clubParis: string;
  clubParisCodeType: ClubType;
  firstName: string;
  secondName?: string;
  babyName?: string;
}
export const AppliedCode = ({
  clubParis,
  clubParisCodeType,
  firstName,
  secondName,
  babyName
}: IClubParisProps) => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery('xl');
  const { sendClubParisRemoveIntentGtm } = useGtmBillingProduct();

  const formatedLabel = !secondName
    ? firstName
    : `${firstName} y ${secondName}`;
  const clubDetails = CLUB_TYPE_DETAILS[clubParisCodeType];

  const handleRemoveClubParis = () => {
    sendClubParisRemoveIntentGtm(clubParis);
    dispatch(setIsRemoveClubParisModalOpen(true));
  };

  return (
    <>
      <div className="co-flex co-flex-col co-pb-24px co-px-16px">
        <div className="co-flex co-py-8px co-px-16px co-gap-8px co-rounded-8px co-border-1 co-border-[#B2E4A8] co-bg-[#E4F7E0] co-items-center co-justify-between">
          <div className="co-w-full co-flex co-gap-8px co-items-center">
            {clubDetails?.icon && (
              <Icon name={clubDetails?.icon} width={32} height={32} />
            )}
            <div className="co-flex co-flex-col co-gap-2px">
              <div className="co-flex co-gap-4px">
                <Typography
                  weight="semibold"
                  leading="16px"
                  color="#002D83"
                  className="co-text-[#002D83]"
                >
                  {`${isMobile ? '' : 'Código '}${clubDetails?.name}`}
                </Typography>
                <Typography
                  weight="semibold"
                  leading="16px"
                  color="#002D83"
                  className="co-text-[#002D83]"
                >
                  {clubParis}
                </Typography>
              </div>
              {clubDetails?.title && (
                <TextItem title={clubDetails?.title} value={formatedLabel} />
              )}
              {babyName && <TextItem title={'Bebé:'} value={babyName} />}
            </div>
          </div>
          <div
            className="co-w-24px co-h-24px co-flex co-cursor-pointer co-justify-center co-items-center co-self-start"
            onClick={handleRemoveClubParis}
          >
            <Icon name="close" width={24} height={24} />
          </div>
        </div>
      </div>
      <ModalRemoveClubParis />
    </>
  );
};

const TextItem = ({ title, value }: Record<string, string>) => (
  <div className="co-flex co-gap-4px">
    <Typography
      weight="semibold"
      leading="16px"
      color="#002D83"
      className="co-text-[#002D83]"
    >
      {title}
    </Typography>
    <Typography leading="16px" color="#002D83" className="co-text-[#002D83]">
      {value}
    </Typography>
  </div>
);
